import { I515Form } from 'clickNgo/models/crud/forms'

import { ProfilingCode } from '../model/types'

export const mapProfilingCode = (data: I515Form): ProfilingCode => ({
  code: data.Code,
  codeName: data.CodeName,
  type: data.Type,
  countries: data.Countries,
  entryId: data.EntryId,
  geoMarket: data.GeoMarket,
  roles: data.Roles,
  users: data.Users,
})
